import { apiSlice } from "./api/apiSlice";

const leadSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addLead: builder.mutation({
            query: (lead) => ({
                url: 'lead/create',
                method: 'POST',
                body: lead
            }),
            invalidatesTags: ["Leads"]
        }),
        getAllLeads: builder.query({
            query: () => ({
                url: 'lead/emp'
            }),
            transformResponse: (response, meta, arg) => response.leads,
            providesTags: ['Leads']
        }),
        getFavouriteLeads: builder.query({
            query: () => ({
                url: '/employee/favourite'
            }),
            transformResponse: (response, meta, arg) => response.leads.favouriteLead,
            providesTags: ['Leads']
        }),
        getFavouriteLeadsLatest: builder.query({
            query: () => ({
                url: 'employee/favourite/latest_leads'
            }),
            transformResponse: (response, meta, arg) => response.leads,
            providesTags: ['Leads']
        }),
        getSharedLeads: builder.query({
            query: ({ page, limit, clientID, project, clientPhone, leadID, source, employeeId }) => {
                const params = new URLSearchParams();
                if (page) params.append("page", page);
                if (limit) params.append("limit", limit);
                if (clientID) params.append("clientID", clientID);
                if (project) params.append("project", project);
                if (clientPhone) params.append("clientPhone", clientPhone);
                if (leadID) params.append("leadID", leadID);
                if (source) params.append("source", source);
                if (employeeId) params.append("employeeId", employeeId);
                return {
                    url: `/leadSharing?${params.toString()}`
                };
            },
            transformResponse: (response, meta, arg) => response,
            providesTags: ['Leads']
        }),
        getCalender: builder.query({
            query: () => ({
                url: 'task/calender'
            }),
            transformResponse: (response) => response.calender
        }),
        getTodoListTask: builder.query({
            query: (option) => ({
                url: `/task/overduetask?task=${option}`
            }),
            transformResponse: (response) => response.tasks,
            providesTags: ['Task']
        }),
        getSingleEmployeeLeads: builder.query({
            query: (id) => ({
                url: `/lead/emp/${id}`
            }),
            transformResponse: (response) => response.empLeads
        }),
        searchLeads: builder.query({
            query: ({ clientID, from, projectID, employeeID, classification, source, numTasks, page, limit }) => ({
                url: `/lead/manage_lead/filter?clientID=${clientID}&from=${from}&projectID=${projectID}&employeeId=${employeeID}&classification=${classification}&source=${source}&numTasks=${numTasks}&limit=${limit}&page=${page}`,
            }),
            transformResponse: (response, meta, arg) => response,
            providesTags: ['Leads']
        }),
        searchLeadsFilter: builder.query({
            query: ({ start, end, clientID, projectID, employeeID, leadID, page, pageSize, phoneNumber, callStatus, isNew }) => ({
                url: `/lead/filter/leads?startDate=${start}&endDate=${end}&clientID=${clientID}&projectID=${projectID}&employeeId=${employeeID}&leadID=${leadID}&page=${page}&pageSize=${pageSize}&phoneNumber=${phoneNumber}&callStatus=${callStatus}${isNew ? `&isNew=${isNew}` : ''}`,
            }),
            transformResponse: (response, meta, arg) => response,
            providesTags: ['Leads']
        }),
        shareLead: builder.mutation({
            query: (lead) => ({
                url: 'leadSharing/create',
                method: 'POST',
                body: lead
            }),
            invalidatesTags: ["Leads"]
        }),
        assignLeads: builder.mutation({
            query: (leadAssignmentData) => ({
                url: '/lead/assign_inactive_leads',
                method: 'PUT',
                body: leadAssignmentData
            }),
            invalidatesTags: ["Leads"]
        }),
        singleassignLead: builder.mutation({
            query: (lead) => ({
                url: '/lead/assign_single_lead',
                method: 'PUT',
                body: lead
            }),
            invalidatesTags: ["Leads"]
        }),
        Projectassign: builder.mutation({
            query: ({ leadId, projectId }) => ({
                url: `/lead/edit_project/${leadId}`,
                method: 'PUT',
                body: { project: projectId },
            }),
            invalidatesTags: ['Leads'],
        }),
        addFeedback: builder.mutation({
            query: ({ leadId, body }) => ({
                url: `/lead/${leadId}/feedback`,
                method: 'PUT',
                body
            }),
            invalidatesTags: ["Leads"]
        }),
        getManageLeadsFilter: builder.query({
            query: (params) => {
                const queryParams = new URLSearchParams();
                Object.keys(params).forEach(key => {
                    if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
                        queryParams.append(key, params[key]);
                    }
                });
                return {
                    url: `lead/manage_lead/filter?${queryParams.toString()}`
                };
            },
            transformResponse: (response) => response,
            providesTags: ['Leads']
        })
    })
})

export const { useLazyGetSharedLeadsQuery, useShareLeadMutation, useAssignLeadsMutation, useSingleassignLeadMutation, useAddLeadMutation, useGetAllLeadsQuery, useGetFavouriteLeadsQuery, useGetFavouriteLeadsLatestQuery, useGetCalenderQuery, useGetTodoListTaskQuery, useLazyGetSingleEmployeeLeadsQuery, useLazySearchLeadsQuery, useLazySearchLeadsFilterQuery, useProjectassignMutation, useAddFeedbackMutation, useLazyGetManageLeadsFilterQuery } = leadSlice;